'use client'
import { useStdCart } from 'storefront-modules/cart'
import { useSelector } from 'shared-redux'
import { Currency } from 'ecosystem'
import { selectedCart } from 'shared-redux/state'
import { useAppConfigContext } from '#/src/appConfig'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { CurrencyOverrides } from 'storefront-modules/types'
import { useGtmCartEvents } from 'storefront-modules/data-collection'

interface UseCustomCartProps {
  registerViewCartEvent?: boolean
}

export const useCustomCart = (opts?: UseCustomCartProps) => {
  const appConfig = useAppConfigContext()
  const overrides = useOverridesContext<keyof CurrencyOverrides>()
  const state = useSelector(selectedCart)
  const {
    checkoutEvent,
    purchaseEvent,
    removeFromCartEvent,
    viewCartEvent,
    handleAddToCartOrQuantityChange
  } = useGtmCartEvents({
    categories: appConfig.categories,
    cartTotal: state.cartTotal,
    cartItems: state.cartItems,
    currency: overrideText(appConfig.currency ?? Currency.SEK, overrides?.currency) as Currency,
    registerViewCartEvent: !!opts?.registerViewCartEvent
  })

  return useStdCart({
    onAddToCart: handleAddToCartOrQuantityChange,
    onRemoveFromCart: removeFromCartEvent,
    onCheckout: checkoutEvent,
    onPurchase: purchaseEvent,
    onViewCart: viewCartEvent
  })
}
